/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Notfound_BackInputs */

const en_directory_notfound_back = /** @type {(inputs: Directory_Notfound_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to home`)
};

const zh_directory_notfound_back = /** @type {(inputs: Directory_Notfound_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回首页`)
};

/**
* | output |
* | --- |
* | "Back to home" |
*
* @param {Directory_Notfound_BackInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_notfound_back = /** @type {((inputs?: Directory_Notfound_BackInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Notfound_BackInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_notfound_back(inputs)
	return zh_directory_notfound_back(inputs)
});
export { directory_notfound_back as "directory.notfound.back" }